import React from 'react';
import '../styles/theme.css';
import '../styles/Login.css';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import LoginReturningNote from '../components/LoginReturningNote';
import LoginVerificationPanel from '../components/LoginVerificationPanel';
/* IMPORTS */

function LoginPage() {
  return (
    <div className="lo-root">
      <div className="lo-layout-1">
        <div id="loginnavbarslot" className="lo-slot-loginnavbarslot">
          <Navbar activePage={"Login"} />
        </div>
        <div className="lo-layout-2">
          <div id="loginverificationpanel" className="lo-slot-loginverificationpanel">
            <LoginVerificationPanel />
          </div>
          <div id="loginreturningnote" className="lo-slot-loginreturningnote">
            <LoginReturningNote />
          </div>
        </div>
        <div id="loginfooterslot" className="lo-slot-loginfooterslot">
          <Footer />
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
